import React from 'react';
import { FileRejection, useDropzone } from 'react-dropzone';
import FileFolderBuilder, { IFileWithPath } from './FileFolderBuilder';
import FileFolder from './FileFolder';
import { maxBytesPerUpload } from '../../../common/constants';
import { DefaultButton } from '@fluentui/react';

// const fileTooLargeCode = 'file-too-large';

interface IFileDropzoneProps {
  onDrop: (fileFolder: FileFolder) => void | Promise<void>;
  openOnClick?: boolean;
  onUploadTooLarge?: () => void;
  multiple?: boolean;
  children?: JSX.Element;
  disableUploadBtn?: boolean;
  label?: string;
  icon?: string;
}

const FileDropzone: React.FC<IFileDropzoneProps> = (props) => {
  const onDrop = <T extends File & { path?: string }>(acceptedFiles: T[], rejections: FileRejection[]) => {
    if (!acceptedFiles.every((file) => typeof file.path === 'string')) {
      // TODO: error
      return;
    }

    if (rejections.length > 0) {
      if (props.onUploadTooLarge) {
        props.onUploadTooLarge();
      }
    } else if (acceptedFiles.length > 0) {
      const folderStructure = FileFolderBuilder.from(acceptedFiles as IFileWithPath[]);
      if (folderStructure.totalSize() > maxBytesPerUpload) {
        if (props.onUploadTooLarge) {
          props.onUploadTooLarge();
        }
      } else {
        props.onDrop(folderStructure);
      }
    }
  };

  const { getRootProps, getInputProps, isDragActive, isDragAccept, open } = useDropzone({
    noClick: !props.openOnClick,
    noKeyboard: true,
    noDragEventsBubbling: true,
    onDrop,
    maxSize: maxBytesPerUpload,
    onError: (err: any) => console.error(err),
    multiple: props.multiple === undefined ? true : props.multiple,

    // onDropRejected(fileRejections, event) {
    //   // const tooLarge = fileRejections
    //   //   .filter((reject) => reject.errors.some((error) => error.code === fileTooLargeCode))
    //   //   .map((reject) => reject.file)
    //   //   .map((f: File & { path?: string }) => f.name);

    //   if (props.onUploadTooLarge) {
    //     props.onUploadTooLarge();
    //   }
    // },
  });

  return (
    <div
      {...getRootProps({
        className: `d-inline dropzone full-height ${isDragActive && 'dropzone-drag-active'} ${
          isDragAccept && 'dropzone-drag-accept'
        }`,
      })}
    >
      <DefaultButton
        disabled={props.disableUploadBtn}
        text={props.label ? props.label : 'Subir archivo'}
        onClick={() => open()}
        allowDisabledFocus
        width={100}
        iconProps={{ iconName: props.icon ? props.icon : 'Upload' }}
      />

      <input
        {...getInputProps()}
        accept="image/*,application/pdf,application/msword,application/vnd.oasis.opendocument.text,application/rtf"
      />
      {props.children && <>{props.children}</>}
    </div>
  );
};

export default FileDropzone;
